import Modalheader from "../../../components/header";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import ModalBody from "../../../components/body";
import useModal from "../../../useModal";
import ApiDatabase from "server";
import UseContext from "../../../../../hooks/useContext";
import {toast} from "react-toastify";
import {useEffect, useState} from "react";

const ModalExcludeAgency = () => {
    const { toggle } = useModal()
    const {infoVivier, setUsersVivier} = UseContext()
    const [isWaiting, setIsWaiting] = useState(false)
    const [loading, setLoading] = useState(false)
    const [reasonExcludes, setReasonExcludes] = useState([])
    const [reasonSelected, setReasonSelected] = useState('')
    const token = localStorage.getItem('xsrfToken')

    useEffect(() => {
        if (token) {
            setIsWaiting(true)
            ApiDatabase.getReasonExcludeAgency(
                { token },
                (data) => {
                    setReasonExcludes(data || [])
                    setIsWaiting(false)
                },
                (err) => {
                    console.log('err', err)
                    setIsWaiting(false)
                }
            )
        }
    }, [token])

    const handleCancel = () => {
        setReasonSelected('')
        toggle()
    }

    const handleSubmit = () => {
        if (!reasonSelected) {
            toast.error('Veuillez sélectionner un motif d\'exclusion')
            return
        }
        setLoading(true)
        ApiDatabase.postExcludeAgency({token, idUsers: infoVivier.listUsers, reason: reasonSelected}, (res) => {
            toast.success(infoVivier.listUsers?.length > 1 ? 'Les candidats ont étés exclus de l\'agence' : 'Le candidat a été exclu de l\'agence')
            setUsersVivier(res)
            setReasonSelected('')
            setLoading(false)
            toggle()
        }, (err) => {
            setLoading(false)
            if (err.name !== "CanceledError") {
                console.log(err)
            }
        })
    }

    return (
        <>
            <Modalheader hide={handleCancel} hideShow={true}>
                Exclure de l'agence
            </Modalheader>
            <ModalBody>
                {isWaiting ? (
                    <div className="text-center py-4">Chargement ...</div>
                ) : (
                    <div className="flex flex-col gap-4">
                        <div className={'text-gray-500'}>
                            Êtes-vous sûr de vouloir exclure ce candidat de l'agence ? Il ne fera plus parti d'aucun vivier et ne recevra plus de notifications.
                        </div>
                        <div>
                            <label className="ft-sm text-gray-500">
                                <div className="mb-1">Motif d'exclusion</div>
                                <select
                                    className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-gray-900"
                                    value={reasonSelected}
                                    onChange={(e) => setReasonSelected(e.target.value)}
                                >
                                    <option value="">Sélectionnez un motif</option>
                                    {reasonExcludes.map((reason, index) => (
                                        <option key={index} value={reason._id}>
                                            {reason.name}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {loading ? (
                    <>
                        <Button color={'DISABLED'} size={'LG'}>Annuler</Button>
                        <Button color={'DISABLED'} size={'LG'}>Exclusion en cours...</Button>
                    </>
                ) : (
                    <>
                        <Button onClick={handleCancel} color={'SECONDARY'} size={'LG'}>Annuler</Button>
                        <Button onClick={handleSubmit} size={'LG'} disabled={!reasonSelected}>Confirmer</Button>
                    </>
                )}
            </ModalFooter>
        </>
    )
}

export default ModalExcludeAgency;